/**
 * local storage util
 */
let ls_proxy = new Proxy(localStorage, {
    get(target, property) {
        if ('access' === property) {
            if (target[property]) { //如果存在属性
                const access = JSON.parse(target[property]);
                const expires = access.expires;
                if (expires) { //如果时效数据存在
                    if (expires > Date.now()) { //如果有效期未过
                        return access;
                    } else {
                        target.clear();
                        return null;
                    }
                } else {
                    target.clear();
                    return null;
                }
            } else {
                return null;
            }
        }
        return Reflect.get(target, property);
    },
    deleteProperty(target, property) {
        if (property in target) {
            return delete target[property];
        }
    }
});

export default ls_proxy;


// WEBPACK FOOTER //
// ./src/utils/lsUtil.js